/** Shared homepage FAQ copy for every viewport and its FAQPage structured data. */
export const landingFaqItems = [
  {
    id: "launch-requirements",
    question: "What do we need to launch a campaign?",
    answer:
      "Four things to start: a campaign goal, a budget, approved video assets, and your brand guidelines. Source material can be almost any owned footage that would feel at home in a social feed, whether that’s podcasts, trailers, livestreams, UGC, product integrations, behind-the-scenes, or anything else in your library. Our team will walk you through setup and stay hands-on through launch to make sure your first clipping campaign performs. If your asset library is light, we can source cost-effective UGC creative to expand it and give clippers more to work with.",
    defaultOpen: true,
  },
  {
    id: "billing",
    question: "What are we billed for?",
    answer:
      "You are billed for two things only: verified views and Evangelist services, which cover access to the Evangelist platform and, where applicable, a campaign management fee. Platform fees (Vyro, Content Rewards, and similar) are already built into the CPM, so there are no separate line items or surprise charges at the end of a campaign.",
  },
  {
    id: "existing-partners",
    question: "Can we work with our existing clipping partners?",
    answer:
      "Yes. Evangelist integrates with the leading clipping platforms and private networks via API, so your existing relationships carry over. If we don’t already have a direct connection to your preferred partner, we can build one.",
  },
  {
    id: "experience",
    question: "Do we need experience with clipping?",
    answer:
      "Not at all. Our account managers and creative strategists guide you from first concept through campaign results, so you don’t need any prior experience with the format.",
  },
  {
    id: "pricing",
    question: "How is pricing structured?",
    answer:
      "Platform access starts at 10% of media spend, with the rate depending on your spend commitment and campaign volume. Our managed service layer starts at 15%. Clipping campaigns themselves are bought on a fixed CPM and paid out against verified views. If you only need Evangelist for anti-botting and view verification, that’s priced on a set CPM tied to total clip volume, so reach out and we’ll walk through the numbers.",
  },
] as const;
